import { graphql, Link, StaticQuery } from 'gatsby';
import { FluidObject } from 'gatsby-image';
import React from 'react';
import styled from 'styled-components';

import {
  AllFileQueryResponse,
  LocationProps,
  NodeWithPhotoGalleryChildImageSharp,
  PhotoGalleryChildImageSharp,
} from '../../interfaces';
import { Container } from '../../styles/CommonStyledComponents';
import { findImage } from '../../utils/FindImage';
import { getJsonByPathname } from '../../utils/GetJsonByPathname';
import { linkUrl } from '../../utils/LinkUrl';
import { Button } from '../Button';
import { PhotoGallery } from '../PhotoGallery';

interface GalleryProps {
  location: LocationProps;
}

interface HomeGalleryImage {
  homeGalleryImage: string;
}

interface HomeGalleryJsonNode {
  homeGallery: HomeGalleryImage[];
  parent: {
    name: string;
  };
}
interface Node {
  node: {
    smallImage: FluidObject;
    bigImage: FluidObject;
  };
}

interface QueryResponse extends AllFileQueryResponse<NodeWithPhotoGalleryChildImageSharp> {
  subpagesJson: {
    url: string;
  };
  allHomeGalleryJson: {
    nodes: HomeGalleryJsonNode[];
  };
  allImageSharp: {
    edges: Node[];
  };
}

const query = graphql`
  query {
    allHomeGalleryJson {
      nodes {
        homeGallery {
          homeGalleryImage
        }
        parent {
          ... on File {
            name
          }
        }
      }
    }
    allImageSharp {
      edges {
        node {
          smallImage: fluid(maxWidth: 400, maxHeight: 300, quality: 80) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
          bigImage: fluid(maxWidth: 1200, quality: 90) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
    subpagesJson(key: { eq: "gallery" }) {
      url
    }
  }
`;

const HomeGalleryContainer = styled(Container)`
  text-align: center;
`;

const HomeGallery = (props: GalleryProps) => {
  return (
    <StaticQuery
      query={query}
      render={(data: QueryResponse) => (
        <HomeGalleryContainer>
          <PhotoGallery
            photos={findPhotos(data, props.location.pathname)}
            title="Galeria zdjęć"
            withImages={true}
          ></PhotoGallery>
          <Link to={linkUrl(props.location.pathname, data.subpagesJson.url)}>
            <Button>Zobacz wszystko</Button>
          </Link>
        </HomeGalleryContainer>
      )}
    />
  );
};

function findPhotos(data: QueryResponse, pathname: string): PhotoGalleryChildImageSharp[] {
  const homeGallery = getJsonByPathname<HomeGalleryJsonNode, QueryResponse>(data, pathname, 'allHomeGalleryJson')
    ?.homeGallery;
  if (!homeGallery) {
    return [];
  }
  return homeGallery.map((image: HomeGalleryImage) => {
    return {
      smallImage: findImage(image.homeGalleryImage, data, 'smallImage'),
      bigImage: findImage(image.homeGalleryImage, data, 'bigImage'),
    };
  });
}

export default HomeGallery;
